import React, { ReactNode, useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './FreeTierLimitIndicator.scss'
import { MissingScopeAction } from '../ScopedBlock/models'
import { ScopedBlock } from '../ScopedBlock/ScopedBlock'
import { useSessionAvailability } from '../ScopedBlock/hooks'

type SessionLimitIndicatorProps = {
  atLimitElement?: ReactNode
}
export const SessionLimitIndicator: React.FC<SessionLimitIndicatorProps> = ({ atLimitElement = null }) => {
  const [maxRoomSessions, setMaxRoomSessions] = useState<number | null>(null)
  const [usedRoomSessions, setUsedRoomSessions] = useState(0)
  const { maxSessionsInPeriod, usedSessionsInPeriod, isSuccess: sessionAvailabilitySuccess } = useSessionAvailability()

  useEffect(() => {
    if (sessionAvailabilitySuccess) {
      setMaxRoomSessions(maxSessionsInPeriod)
      setUsedRoomSessions(usedSessionsInPeriod)
    }
  }, [sessionAvailabilitySuccess, maxSessionsInPeriod, usedSessionsInPeriod])

  return (
    <>
      {maxRoomSessions !== null && (
        <>
          {maxRoomSessions <= usedRoomSessions ? (
            atLimitElement
          ) : (
            <div className='d-flex flex-column gap-2 justify-content-center'>
              <div className='d-flex gap-3'>
                <div className='text-nowrap'>
                  {usedRoomSessions}/{maxRoomSessions} meetings
                </div>
                <ScopedBlock
                  scope={{
                    scope: 'billing_subscription:change',
                    superScope: ['billing_subscription:admin'],
                  }}
                  missingScopeAction={MissingScopeAction.HIDE}
                >
                  <Link className='zocks-text-gray-900 medium text-decoration-underline paragraph-medium' to='/account/plan/plan'>
                    Upgrade
                  </Link>
                </ScopedBlock>
              </div>
              <ProgressBar className='progress-sm' now={Math.floor((usedRoomSessions / maxRoomSessions) * 100)} variant='success'></ProgressBar>
            </div>
          )}
        </>
      )}
    </>
  )
}
